/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TransactionalInputs */

const cs_enum_transactional = /** @type {(inputs: Enum_TransactionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transakční`)
};

const en_enum_transactional = /** @type {(inputs: Enum_TransactionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transactional`)
};

/**
* | output |
* | --- |
* | "Transactional" |
*
* @param {Enum_TransactionalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_transactional = /** @type {((inputs?: Enum_TransactionalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TransactionalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_transactional(inputs)
	return cs_enum_transactional(inputs)
});